import { Step, Stepper, StepButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledStepper = styled(Stepper)`
  width: 100%;

  & .MuiStepConnector-line {
    border-top-color: ${({ theme }) => theme.palette.customGrey.main};
    border-top-style: dashed;
  }

  & .Mui-active,
  & .Mui-completed {
    & .MuiStepConnector-line {
      border-top-color: ${({ theme }) => theme.palette.primary.main};
      border-top-style: solid;
    }
  }

  &.stepper_progress {
    & .MuiStepConnector-line {
      border-top-color: #dee5f2;
      border-top-width: 4px;
      border-top-style: solid;
      border-radius: 8px;
    }

    & .Mui-active,
    & .Mui-completed {
      & .MuiStepConnector-line {
        border-top-color: ${({ theme }) => theme.palette.green.main};
        border-top-style: solid;
      }
    }
  }
`;

const StyledStep = Step;

const StyledStepButton = styled(StepButton)`
  width: 24px;
  height: 24px;
  padding: 0 14px;
  margin: 0 -14px;

  @media (min-width: 768px) {
    width: 32px;
    height: 32px;
    padding: 0 20px;
    margin: 0 -20px;
  }

  &:hover {
    & .MuiStepLabel-iconContainer {
      background-color: ${({ theme }) => theme.palette.primary.main};
      border-color: ${({ theme }) => theme.palette.primary.main};
      transition: all 0.2s linear;
    }

    & .MuiStepIcon-text {
      fill: ${({ theme }) => theme.palette.common.white};
      transition: all 0.2s linear;
    }
  }

  &. & .MuiStepLabel-root {
    width: 100%;
    height: 100%;
  }

  & .MuiStepLabel-iconContainer {
    padding-right: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.palette.customGrey.soft};
    border: ${({ theme }) => `1px solid ${theme.palette.customGrey.main}`};
    border-radius: 50%;
    box-sizing: border-box;
    transition: all 0.2s linear;

    & svg {
      width: 100%;
      height: 100%;
      color: transparent;
    }

    &.Mui-active {
      background-color: ${({ theme }) => theme.palette.primary.main};
      border-color: ${({ theme }) => theme.palette.primary.main};

      & .MuiStepIcon-text {
        fill: ${({ theme }) => theme.palette.common.white};
      }
    }

    &.Mui-completed {
      background-color: ${({ theme }) => theme.palette.common.white};
      border-color: ${({ theme }) => theme.palette.primary.main};

      & svg {
        fill: ${({ theme }) => theme.palette.primary.main};
        stroke: ${({ theme }) => theme.palette.primary.main};
      }
    }
  }

  & .MuiStepIcon-text {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.bodyL?.fontSize};
    line-height: ${({ theme }) => theme.typography.bodyL?.lineHeight};
    fill: ${({ theme }) => theme.palette.common.black};
    transition: all 0.2s linear;

    @media (min-width: 768px) {
      font-size: ${({ theme }) => theme.typography.bodyM?.fontSize};
      line-height: ${({ theme }) => theme.typography.bodyM?.lineHeight};
    }
  }

  &.Mui-disabled {
    & .MuiStepIcon-text {
      fill: ${({ theme }) => theme.palette.customGrey.main};
    }
  }
`;

export { StyledStepper, StyledStep, StyledStepButton };
